import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

export const styles = (theme) => ({
  textElementStyleLight: {
    base: {
      fontSize: 14,
      fontFamily: theme.typography.fontFamily,
      color: theme.colorPalette.green_75,
      fontWeight: 400,
      backgroundColor: theme.palette.common.white,
      '::placeholder': {
        fontSize: 14,
        color: theme.colorPalette.grey_10_op_38
      },
      padding: 10
    },
    // Once input is valid the element applies the `complete` variant; without an explicit color
    // here the text falls back to the browser default (renders blue). Keep it in brand green.
    complete: {
      color: theme.colorPalette.green_75
    },
    invalid: {
      color: theme.palette.error.main
    }
  },
  textElementStyleDark: {
    base: {
      fontSize: 14,
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.common.white,
      fontWeight: 400,
      backgroundColor: theme.colorPalette.white_op_15,
      '::placeholder': {
        fontSize: 14,
        color: theme.colorPalette.beige_50_op_75
      },
      padding: 10
    },
    complete: {
      color: theme.palette.common.white
    },
    invalid: {
      color: theme.palette.error.main
    }
  }
});

// Wrapper styles applied to the host div surrounding each BasisTheory iframe.
// Border and focus ring must live here (outside the iframe) since the SDK's
// SafeStyle whitelist does not include border/boxShadow.
export const useWrapperStyles = makeStyles((theme) => ({
  wrapper: {
    ...reskinStyles(theme, {
      border: `1px solid ${theme.colors.form_border_primary}`,
      borderRadius: 23,
      overflow: 'hidden',
      transition: 'border-color 0.15s ease'
    })
  },
  wrapperFocused: {
    ...reskinStyles(theme, {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2
    })
  }
}));
